import { Icon } from "../ui/Icon";
import { type TableColumn, type ColType, COL_TYPES, COL_TYPE_LABEL, blankColumn } from "../../lib/formTable";

/** Builder'da tablo alanının kolonlarını tanımlar: başlık + tip + (seçim seçenekleri / sayı birimi) + zorunlu. */
export function TableColumnsEditor({ value, onChange }: { value: TableColumn[]; onChange: (cols: TableColumn[]) => void }) {
  const patch = (i: number, p: Partial<TableColumn>) => onChange(value.map((c, idx) => (idx === i ? { ...c, ...p } : c)));
  const add = () => onChange([...value, blankColumn()]);
  const remove = (i: number) => onChange(value.filter((_, idx) => idx !== i));
  const move = (i: number, dir: -1 | 1) => {
    const j = i + dir;
    if (j < 0 || j >= value.length) return;
    const next = [...value];
    const [a] = next.splice(i, 1);
    next.splice(j, 0, a!);
    onChange(next);
  };

  return (
    <div className="fb-cols">
      {value.map((c, i) => (
        <div className="fb-col-card" key={c.key}>
          <div className="fb-col-head">
            <span className="fb-col-num">{i + 1}</span>
            <input className="form-input" value={c.label} placeholder="Kolon başlığı" maxLength={200} onChange={(e) => patch(i, { label: e.target.value })} />
            <button type="button" className="fb-iact" aria-label="Yukarı taşı" title="Yukarı taşı" disabled={i === 0} onClick={() => move(i, -1)}><Icon name="chevronUp" size={13} /></button>
            <button type="button" className="fb-iact" aria-label="Aşağı taşı" title="Aşağı taşı" disabled={i === value.length - 1} onClick={() => move(i, 1)}><Icon name="chevronDown" size={13} /></button>
            <button type="button" className="fb-iact danger" aria-label="Kolonu sil" title="Kolonu sil" onClick={() => remove(i)}><Icon name="trash" size={13} /></button>
          </div>
          <div className="fb-col-row">
            <select className="form-select" value={c.type} aria-label="Kolon tipi" onChange={(e) => { const t = e.target.value as ColType; patch(i, t === "boolean" ? { type: t, required: false } : { type: t }); }}>
              {COL_TYPES.map((t) => <option key={t} value={t}>{COL_TYPE_LABEL[t]}</option>)}
            </select>
            {c.type === "number" ? (
              <input className="form-input" value={c.unit ?? ""} placeholder="Birim (kg, dk…)" maxLength={30} aria-label="Birim" onChange={(e) => patch(i, { unit: e.target.value || null })} />
            ) : null}
            {c.type !== "boolean" ? (
              <label className="fb-col-req"><input type="checkbox" checked={c.required} onChange={(e) => patch(i, { required: e.target.checked })} />Zorunlu</label>
            ) : null}
          </div>
          {c.type === "select" ? (
            <textarea className="form-textarea" rows={2} value={c.options.join("\n")} placeholder={"Seçenek 1\nSeçenek 2"} aria-label="Seçenekler (her satır bir seçenek)" onChange={(e) => patch(i, { options: e.target.value.split("\n") })} />
          ) : null}
        </div>
      ))}
      <button type="button" className="btn-md secondary" style={{ height: 30, padding: "0 11px", fontSize: 12.5, alignSelf: "flex-start" }} onClick={add}>
        <Icon name="plus" size={13} />Kolon ekle
      </button>
    </div>
  );
}
